module.exports = __webpack_public_path__ + "static/media/1_14.519bf9ab.jpg";